import { call, put, takeLatest } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';

import * as actions from '../actions';
import * as types from '../actionTypes';

/** @param {import('../types/actions').FetchServiceHeaderAction} action */
function* getServiceHeader({ payload, meta }) {
  const { request } = payload;
  try {
    const { data: entries } = yield call(restClient.request, request);
    yield put(actions.fetchServiceHeaderSuccess(entries, meta));
  } catch (error) {
    yield put(actions.fetchServiceHeaderFailure(error, meta));
  }
}

/** @param {import('../types/actions').FetchServiceHeaderSuccessAction} action */
function* autoSelectServiceHeader({ payload, meta }) {
  const { autoSelect = true } = meta;
  if (autoSelect) {
    if (payload.length === 1) {
      const [entry] = payload;
      yield put(actions.selectEntry(entry, meta));
    } else {
      yield put(actions.openModal(undefined, meta));
    }
  }
}

export default function* SHSagas() {
  yield takeLatest(types.FETCH_SERVICE_HEADER, getServiceHeader);
  yield takeLatest(types.FETCH_SERVICE_HEADER_SUCCESS, autoSelectServiceHeader);
}
